import React from 'react';
import DENTModalOverviewSurfaces from '../DENTModalOverviewSurfaces/DENTModalOverviewSurfaces';
import { useDENTContext } from '../../Services/DENTContext';
import { useToothRestorationSurfaces } from '../../Hooks/Tooth/Restoration/useToothRestorationSurfaces';
import useToothRestorationFillingSurfaces from '../../Hooks/Tooth/Restoration/useToothRestorationFillingSurfaces';
// @ts-ignore
import styles from './DENTModalOverviewRestoration.module.scss';
import DENTModalOverviewRestorationButtons from '../DENTModalOverviewRestorationButtons/DENTModalOverviewRestorationButtons';
import { RESTORATION_BUTTON_OPTIONS } from '../../Helpers/restoration/restorationButtonOptions';
import DENTModalOverviewActionButtons from '../DENTModalOverviewActionButtons/DENTModalOverviewActionButtons';
import { ToothRestorationType } from '../../../../graphql/graphql';

interface Props {
	onClose: () => void;
}

const DENTModalOverviewRestoration = ({ onClose }: Props) => {
	const { activeTooth, handleUpdateTooth } = useDENTContext();

	const generalSurfaces = useToothRestorationSurfaces();
	const fillingSurfaces = useToothRestorationFillingSurfaces();

	const isFilling =
		generalSurfaces.selectedSection.value === ToothRestorationType.Filling;
	const surfaceHandler = isFilling ? fillingSurfaces : generalSurfaces;

	const handleSubmit = async () => {
		if (!activeTooth?.restoration) return;

		handleUpdateTooth({
			restoration: activeTooth.restoration,
		});
	};

	if (!activeTooth) {
		return <></>;
	}

	const surfaceHandlerForComponent = {
		showedSurfaces: surfaceHandler.showedSurfaces,
		selectedSurfaces: surfaceHandler.selectedSurfaces,
		handleSelectSurface: surfaceHandler.handleSelectSurface,
	};

	return (
		<div className={styles.container}>
			<DENTModalOverviewSurfaces
				onSelectSurface={surfaceHandler.handleSelectSurface}
				surfaces={surfaceHandlerForComponent}
			/>
			<div className={styles.buttonsContainer}>
				<DENTModalOverviewRestorationButtons
					selectedOption={generalSurfaces.selectedSection}
					setSelectedOption={generalSurfaces.handleSelectSection}
					options={RESTORATION_BUTTON_OPTIONS[activeTooth.type]}
					onClose={onClose}
					fillingIndex={isFilling ? fillingSurfaces.fillingIndex : 0}
					setFillingIndex={
						isFilling ? fillingSurfaces.setFillingIndex : () => {}
					}
				/>
				<DENTModalOverviewActionButtons onSubmit={handleSubmit} />
			</div>
		</div>
	);
};

export default DENTModalOverviewRestoration;
